import OrganizationService from '../../services/OrganizationService'
import AxiosErrorHandler from '../../helpers/AxiosErrorHandler'
import router from '../../router'
import ProjectsService from '../../services/ProjectsService'
export const namespaced = true

const initialState = {
  organizations: [],
  selectedOrganization: null,
  projectsForOrganization: [],
  usersForOrganization: [],
  organizationsForUsers: []
}

export const state = {
  organizations: [],
  projectsForOrganization: [],
  usersForOrganization: [],
  organizationsForUsers: [],
  selectedOrganization: null
}

export const mutations = {
  SET_ORGANIZATIONS(state, recs) {
    state.organizations = recs
  },
  SET_PROJECTS_ORGANIZATION(state, recs) {
    state.projectsForOrganization = recs
  },
  SET_USERS_ORGANIZATION(state, recs) {
    state.usersForOrganization = recs
  },
  SET_ORGANIZATIONS_FOR_USERS(state, recs) {
    state.organizationsForUsers = recs
  },
  SET_SELECTED_ORGANIZATION(state, rec) {
    state.selectedOrganization = rec
  },
  RESET_STORE(state) {
    Object.assign(state, initialState)
  }
}

export const actions = {
  fetchOrganizations: function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    console.log('FETCHING ORG')
    return OrganizationService.getOrganizations().then(
      r => {
        context.commit('SET_ORGANIZATIONS', r.data)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      },
      e => {
        context.commit('SET_ORGANIZATIONS', null)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  fetchOrganizationsForUsers: function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    return OrganizationService.getOrganizationsForUsers().then(
      r => {
        context.commit('SET_ORGANIZATIONS_FOR_USERS', r.data)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      },
      e => {
        context.commit('SET_ORGANIZATIONS_FOR_USERS', null)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  fetchProjectsForOrganization: function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    return OrganizationService.getProjectsForOrganization(value).then(
      r => {
        context.commit('SET_PROJECTS_ORGANIZATION', r.data)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      },
      e => {
        context.commit('SET_PROJECTS_ORGANIZATION', null)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  fetchUsersForOrganization: function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    return OrganizationService.getUsersForOrganization(value).then(
      r => {
        context.commit('SET_USERS_ORGANIZATION', r.data)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      },
      e => {
        context.commit('SET_USERS_ORGANIZATION', null)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  setSelectedOrganization: function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    return OrganizationService.getOrganizationById(value).then(
      r => {
        context.commit('SET_SELECTED_ORGANIZATION', r.data)
        context.dispatch(
          'BreadcrumbsStore/add',
          {
            text: 'ORGANIZATION',
            name: r.data.name
          },
          { root: true }
        )
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      },
      e => {
        context.commit('SET_SELECTED_ORGANIZATION', null)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  addOrganization: async function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })

    await OrganizationService.createOrganization(value)
    context.dispatch('fetchOrganizations')
  },
  createOrganizationUser: async function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })

    await OrganizationService.createOrganizationUser(value)
  },
  createOrganizationProject: async function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })

    await OrganizationService.createOrganizationProject(value)
  },
  updateOrganization: async function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    return OrganizationService.updateOrganization(value).then(
      res => {
        context.commit('SET_SELECTED_ORGANIZATION', res.data)
        context.dispatch(
          'BreadcrumbsStore/update',
          {
            text: 'ORGANIZATION',
            name: res.data.name
          },
          { root: true }
        )

        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        context.dispatch('fetchOrganizations', value.organizationsId)
      },
      e => {
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  removeOrganizationUser: async function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    await OrganizationService.detachOrganizationUser(value)
  },
  removeOrganizationProject: async function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    await OrganizationService.detachOrganizationProject(value)
  },
  resetStore: async function(context) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    context.commit('RESET_STORE')
    context.commit('SET_LOADING_STATUS', 'idle', { root: true })
  }
}

export const getters = {
  getSelectedOrganizationId: state => {
    return state.selectedOrganization ? state.selectedOrganization.id : 0
  }
}
